export default "__VITE_ASSET__99e6d943__"